
<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="btn btn-file py-0" tabindex="500" style="height:23px"><img style="vertical-align:unset;margin-left:4px;" src="/icons/Qr_100x100_px.png" width="20" height="20" />  <span class="hidden-xs"><!--Browse--></span><input type="file" class="file-input-caption" v-bind:id="'fileupload' + getId()" accept="image/*" capture="environment"></div>
        <span class="ml-1">{{text}}</span>
      </div>
    </div>
  </div>
</template>

<script>

  
  export default {
    name: 'upload-button-camera-noaction',
    components: {

    },
    props: {
      text: {
        type: String,
        default: ""
      },
    },
    data() {
      return {
        capture: "",
        accept: "",
        forceRecent: false,
      }
    },
    methods: {
      getId() {
        return this._uid;
      },
      
      selectFile(event) {
        
      },
      reset() {
        
      },
      forceRecency(val) {
        this.forceRecent = val;
      },
      setText(text) {
        this.text = text;
      },
      setCapture(capture) {
        this.capture = capture;
      },
      setAccept(accept) {
        this.accept = accept;
      },
      setUid(v) {
        this.uid = v;
      },

    },
    created() {

    },
    mounted() {
      
    }
  }
</script>

<style scoped>
  .btn-outline-grey {
    color: #aaa;
    border-color: #aaa;
  }
  .btn-outline-grey:not(:disabled):not(.disabled).active, .btn-outline-grey:not(:disabled):not(.disabled):active, .show > .btn-outline-grey {
    color: #fff;
    background-color: #aaa;
    border-color: #aaa;
  }
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-button-camera-noaction.vue